import { Plan } from '../../containers/shared/auth/rules';

// IB-1897: Grants is included in Premium, Business and Enterprise. Other funder plans see the menu item with
// the premium diamond and an upgrade prompt. The server refuses every Grants call below these plans.
export const GRANTS_PLANS: Plan[] = ['PREMIUM', 'BUSINESS', 'ENTERPRISE'];

export const hasGrantsPlan = (plan: Plan | string | null | undefined) => GRANTS_PLANS.indexOf(plan as Plan) >= 0;
